(function () {
  "use strict";

  var BOOKING_ORIGIN = "https://alunirbooking.lovable.app";
  var META_PIXEL_ID = "168984784056868";
  var LEGACY_VARIANT_STORES = {
    55196600074623: "st-gallen",
    55606492791167: "zuerich",
    58071503569279: "schaffhausen-popup",
    48875235442968: "st-gallen",
    47858661818648: "heerbrugg",
    55511810343295: "zuerich",
  };
  var modalState = null;
  var root = null;
  var selectedOffering = null;
  var pageContent = null;
  var trackingSessionId = null;

  function bookingTrackingSession() {
    if (!trackingSessionId) {
      trackingSessionId =
        window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : "shopify-" + Date.now() + "-" + Math.random().toString(16).slice(2);
    }
    return trackingSessionId;
  }

  function productHandle() {
    return root ? root.getAttribute("data-alunir-booking-handle") || "" : "";
  }

  function serviceSlug() {
    return root ? root.getAttribute("data-alunir-booking-service") || "" : "";
  }

  function bookingFlow() {
    return root ? root.getAttribute("data-alunir-booking-flow") || null : null;
  }

  function baseBookingUrl() {
    return root ? root.getAttribute("data-alunir-booking-url") || "" : "";
  }

  function localizedLabel(name) {
    return root ? root.getAttribute("data-alunir-booking-" + name) || "" : "";
  }

  function cleanTrackingValue(value, maxLength) {
    if (!value) return null;
    var normalized =
      String(value)
        .replace(/[\u0000-\u001f\u007f]/g, "")
        .trim()
        .slice(0, maxLength || 500) || null;
    if (!normalized) return null;
    if (/\{\{\s*[^{}]+\s*\}\}|%7b%7b[^%]*(?:%7d%7d)/i.test(normalized)) return null;
    return normalized;
  }

  function firstTrackingValue(primary, secondary, fallback) {
    return (
      cleanTrackingValue(primary) || cleanTrackingValue(secondary) || cleanTrackingValue(fallback)
    );
  }

  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.marketingAllowed !== "function") return false;
      return privacy.marketingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function firstPartyCookie(name) {
    var prefix = name + "=";
    var parts = String(document.cookie || "").split(";");
    for (var i = 0; i < parts.length; i += 1) {
      var value = parts[i].trim();
      if (value.indexOf(prefix) === 0)
        return cleanTrackingValue(decodeURIComponent(value.slice(prefix.length)));
    }
    return null;
  }

  function requestedStoreSlug() {
    try {
      var search = new URL(window.location.href).searchParams;
      var explicit = cleanTrackingValue(search.get("booking_store"), 120);
      if (explicit) return explicit.toLowerCase();
      return LEGACY_VARIANT_STORES[search.get("variant")] || null;
    } catch (error) {
      return null;
    }
  }

  function storedAttribution() {
    try {
      if (
        !marketingAllowed() ||
        !window.AlunirAttribution ||
        typeof window.AlunirAttribution.get !== "function"
      )
        return null;
      return window.AlunirAttribution.get();
    } catch (error) {
      return null;
    }
  }

  function bookingAttribution() {
    var output = {};
    try {
      var page = new URL(window.location.href);
      var persisted = storedAttribution();
      var lastPaidTouch = persisted && persisted.last_paid_touch;
      var firstTouch = persisted && persisted.first_touch;
      var touch = lastPaidTouch || firstTouch;
      ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "fbadid"].forEach(
        function (key) {
          var value = firstTrackingValue(
            lastPaidTouch && lastPaidTouch[key],
            firstTouch && firstTouch[key],
            page.searchParams.get(key),
          );
          if (value) output[key] = value;
        },
      );
      output.landing_page =
        cleanTrackingValue(touch && touch.landing_page) || page.origin + page.pathname;
      output.marketing_consent = marketingAllowed() ? "1" : "0";
      if (page.searchParams.get("booking_qa") === "1") output.booking_qa = "1";
      if (output.marketing_consent === "1") {
        var fbclid = firstTrackingValue(
          lastPaidTouch && lastPaidTouch.fbclid,
          firstTouch && firstTouch.fbclid,
          page.searchParams.get("fbclid"),
        );
        var fbp = firstPartyCookie("_fbp");
        var fbc = firstPartyCookie("_fbc");
        if (!fbc && fbclid) fbc = "fb.1." + Date.now() + "." + fbclid;
        if (fbclid) output.fbclid = fbclid;
        if (fbp) output.fbp = fbp;
        if (fbc) output.fbc = fbc;
      }
    } catch (error) {
      return output;
    }
    return output;
  }

  function sendAttributionToBooking(targetWindow) {
    var attribution = storedAttribution();
    if (!attribution || !targetWindow || typeof targetWindow.postMessage !== "function")
      return false;
    targetWindow.postMessage(
      { type: "alunir:booking-attribution", version: 1, attribution: attribution },
      BOOKING_ORIGIN,
    );
    return true;
  }

  function ensureMetaPixel() {
    if (window.fbq) return window.fbq;
    var fbq = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    window.fbq = fbq;
    window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    var script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    var firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode)
      firstScript.parentNode.insertBefore(script, firstScript);
    else document.head.appendChild(script);
    fbq("init", META_PIXEL_ID);
    return fbq;
  }

  function publishMetaSchedule(eventId) {
    if (!eventId || !marketingAllowed()) return false;
    var fbq = ensureMetaPixel();
    fbq("track", "Schedule", { content_name: serviceSlug() }, { eventID: eventId });
    return true;
  }
  function currentBookingUrl() {
    try {
      var url = new URL(baseBookingUrl(), window.location.href);
      if (selectedOffering) url.searchParams.set("store", selectedOffering.store_slug);
      else url.searchParams.delete("store");
      url.searchParams.set("source_session", bookingTrackingSession());
      var attribution = bookingAttribution();
      Object.keys(attribution).forEach(function (key) {
        url.searchParams.set(key, attribution[key]);
      });
      return url.toString();
    } catch (error) {
      return baseBookingUrl();
    }
  }

  function offeringContext() {
    return selectedOffering
      ? {
          offering_id: selectedOffering.id,
          event_id: selectedOffering.kind === "event" ? selectedOffering.id : null,
          offering_kind: selectedOffering.kind,
          offering_label: selectedOffering.label,
          store_id: selectedOffering.store_id,
          store_slug: selectedOffering.store_slug,
        }
      : {
          offering_id: null,
          event_id: null,
          offering_kind: null,
          offering_label: null,
          store_id: null,
          store_slug: null,
        };
  }

  function track(action, extra) {
    var payload = Object.assign(
      {
        event: action,
        product_handle: productHandle(),
        service_slug: serviceSlug(),
        booking_flow: bookingFlow(),
        booking_surface: "shopify_pdp_modal",
        tracking_session_id: bookingTrackingSession(),
        source: "shopify_pdp",
        device_type: window.matchMedia("(max-width: 740px)").matches ? "mobile" : "desktop",
      },
      offeringContext(),
      bookingAttribution(),
      extra || {},
    );
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent("alunir:booking-tracking", { detail: payload }));
  }

  function formatDate(value) {
    if (!value) return "";
    var locale = (root && root.getAttribute("data-alunir-booking-locale")) || "de-CH";
    return new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date(value + "T12:00:00Z"));
  }

  function eventDate(offering) {
    if (!offering.start_date) return "";
    if (!offering.end_date || offering.start_date === offering.end_date)
      return formatDate(offering.start_date);
    return formatDate(offering.start_date) + " – " + formatDate(offering.end_date);
  }

  function makeOfferingButton(offering) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "alunir-booking-offering" + (offering.kind === "event" ? " is-event" : "");
    button.setAttribute("data-alunir-booking-offering", offering.id);
    button.setAttribute("aria-pressed", "false");

    var label = document.createElement("span");
    label.className = "alunir-booking-offering__label";
    label.textContent = offering.label;
    button.appendChild(label);

    var meta = document.createElement("span");
    meta.className = "alunir-booking-offering__meta";
    if (offering.kind === "event") {
      meta.textContent = eventDate(offering);
    } else {
      meta.textContent = offering.address || localizedLabel("store-appointment");
    }
    button.appendChild(meta);
    button.addEventListener("click", function () {
      selectOffering(offering, button);
    });
    return button;
  }

  function renderOfferingGroup(container, title, offerings, kind) {
    if (!offerings.length) return;
    var group = document.createElement("div");
    group.className = "alunir-booking-offering-group is-" + kind;
    var heading = document.createElement("div");
    heading.className = "alunir-booking-offering-group__title";
    heading.textContent = title;
    group.appendChild(heading);
    var grid = document.createElement("div");
    grid.className = "alunir-booking-offering-group__grid";
    offerings.forEach(function (offering) {
      grid.appendChild(makeOfferingButton(offering));
    });
    group.appendChild(grid);
    container.appendChild(group);
  }

  function selectOffering(offering, button, trackingExtra) {
    selectedOffering = offering;
    root.querySelectorAll("[data-alunir-booking-offering]").forEach(function (candidate) {
      candidate.setAttribute("aria-pressed", candidate === button ? "true" : "false");
    });
    var link = root.querySelector("[data-alunir-booking-fallback]");
    if (link) link.href = currentBookingUrl();
    var mobileBar = root.querySelector("[data-alunir-booking-mobile-bar]");
    var mobileLabel = root.querySelector("[data-alunir-booking-mobile-store]");
    if (mobileLabel) mobileLabel.textContent = offering.label;
    if (mobileBar) {
      mobileBar.classList.add("is-visible");
      mobileBar.setAttribute("aria-hidden", "false");
    }
    track(
      offering.kind === "event" ? "alunir_booking_event_select" : "alunir_booking_store_select",
      trackingExtra,
    );
  }

  function autoSelectRequestedOffering(offerings) {
    var search = new URL(window.location.href).searchParams;
    var explicitStore = cleanTrackingValue(search.get("booking_store"), 120);
    var variantId = cleanTrackingValue(search.get("variant"), 30);
    var offering = null;
    var selectionMethod = null;

    if (explicitStore) {
      offering = offerings.find(function (row) {
        return row.store_slug === explicitStore.toLowerCase();
      });
      if (offering) selectionMethod = "booking_store";
    }
    if (!offering && variantId) {
      offering = offerings.find(function (row) {
        return (
          Array.isArray(row.shopify_variant_ids) &&
          row.shopify_variant_ids.indexOf(variantId) !== -1
        );
      });
      if (offering) selectionMethod = "configured_variant";
    }
    if (!offering) {
      var requested = requestedStoreSlug();
      if (requested) {
        offering = offerings.find(function (row) {
          return row.store_slug === requested;
        });
        if (offering) selectionMethod = "legacy_variant";
      }
    }
    if (!offering) return false;
    var button = root.querySelector('[data-alunir-booking-offering="' + offering.id + '"]');
    if (!button) return false;
    selectOffering(offering, button, { selection_method: selectionMethod });
    return true;
  }
  function setText(selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value || "";
    return element;
  }

  function renderEmbedContent(content) {
    if (!content || typeof content !== "object") return;
    pageContent = content;
    var intro = setText("[data-alunir-content-intro]", content.intro);
    if (intro) intro.hidden = !content.intro;
    var secondary = setText("[data-alunir-content-secondary]", content.secondary_text);
    if (secondary) secondary.hidden = !content.secondary_text;

    var facts = root.querySelector("[data-alunir-content-facts]");
    if (facts && Array.isArray(content.facts)) {
      facts.innerHTML = "";
      content.facts.forEach(function (fact) {
        if (!fact || !fact.label || !fact.value) return;
        var item = document.createElement("div");
        item.className = "alunir-booking-fact";
        var label = document.createElement("span");
        label.className = "alunir-booking-fact__label";
        label.textContent = fact.label;
        var value = document.createElement("span");
        value.className = "alunir-booking-fact__value";
        value.textContent = fact.value;
        item.appendChild(label);
        item.appendChild(value);
        facts.appendChild(item);
      });
    }

    setText("[data-alunir-content-cta]", content.cta_label);
    setText("[data-alunir-content-booking-note]", content.booking_note);
    setText("[data-alunir-content-mobile-cta]", content.mobile_cta_label);

    var proof = root.querySelector("[data-alunir-content-proof-wrap]");
    setText("[data-alunir-content-proof]", content.proof_text);
    if (proof) proof.hidden = !content.proof_text;

    var review = root.querySelector("[data-alunir-content-review]");
    setText("[data-alunir-content-review-quote]", content.review_quote);
    setText("[data-alunir-content-review-attribution]", content.review_attribution);
    if (review) review.hidden = !content.review_enabled || !content.review_quote;

    var occasions = root.querySelector("[data-alunir-content-occasions]");
    setText("[data-alunir-content-occasions-title]", content.occasions_title);
    var list = root.querySelector("[data-alunir-content-occasions-list]");
    if (list && Array.isArray(content.occasions)) {
      list.innerHTML = "";
      content.occasions.forEach(function (occasion) {
        if (!occasion) return;
        var item = document.createElement("li");
        item.textContent = occasion;
        list.appendChild(item);
      });
    }
    if (occasions)
      occasions.hidden =
        !content.occasions_title || !content.occasions || !content.occasions.length;
  }
  function renderFaqs(faqs) {
    var container = root.querySelector("[data-alunir-booking-faq]");
    if (!container) return;
    container.innerHTML = "";
    if (!faqs.length) {
      container.hidden = true;
      return;
    }
    container.hidden = false;
    var heading = document.createElement("h2");
    heading.className = "alunir-booking-faq__title";
    heading.textContent =
      pageContent && pageContent.faq_title
        ? pageContent.faq_title
        : localizedLabel("faq-title");
    container.appendChild(heading);
    faqs.forEach(function (faq) {
      if (!faq || !faq.question || !faq.answer) return;
      var details = document.createElement("details");
      var summary = document.createElement("summary");
      summary.textContent = faq.question;
      details.appendChild(summary);
      var answer = document.createElement("div");
      String(faq.answer)
        .split(/\n\s*\n/)
        .forEach(function (paragraph) {
          if (!paragraph.trim()) return;
          var text = document.createElement("p");
          text.textContent = paragraph.trim();
          answer.appendChild(text);
        });
      details.appendChild(answer);
      container.appendChild(details);
    });
  }
  function loadOfferings() {
    var container = root.querySelector("[data-alunir-booking-offerings-content]");
    var base = root.getAttribute("data-alunir-booking-base-url") || BOOKING_ORIGIN;
    var apiUrl = new URL(
      base.replace(/\/$/, "") +
      "/api/public/services/" +
      encodeURIComponent(serviceSlug()) +
      "/offerings"
    );
    apiUrl.searchParams.set(
      "lang",
      ((root && root.getAttribute("data-alunir-booking-locale")) || "de").toLowerCase().split("-")[0]
    );
    fetch(apiUrl.toString(), {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Offering API " + response.status);
        return response.json();
      })
      .then(function (payload) {
        var offerings = Array.isArray(payload.offerings) ? payload.offerings : [];
        if (payload.content) renderEmbedContent(payload.content);
        if (Array.isArray(payload.faqs)) renderFaqs(payload.faqs);
        container.innerHTML = "";
        renderOfferingGroup(
          container,
          (pageContent && pageContent.stores_title) || localizedLabel("stores-title"),
          offerings.filter(function (row) {
            return row.kind === "store";
          }),
          "stores",
        );
        renderOfferingGroup(
          container,
          (pageContent && pageContent.events_title) || localizedLabel("events-title"),
          offerings.filter(function (row) {
            return row.kind === "event";
          }),
          "events",
        );
        if (!offerings.length)
          container.textContent =
            (pageContent && pageContent.locations_empty_text) ||
            localizedLabel("locations-empty");
        autoSelectRequestedOffering(offerings);
        track("alunir_booking_offering_list_view", {
          offering_count: offerings.length,
          event_count: offerings.filter(function (row) {
            return row.kind === "event";
          }).length,
        });
      })
      .catch(function () {
        container.textContent =
          (pageContent && pageContent.locations_error_text) ||
          localizedLabel("locations-error");
        track("alunir_booking_offering_list_error");
      });
  }

  function embedUrl(url) {
    try {
      var parsed = new URL(url, window.location.href);
      parsed.searchParams.set("embed", "1");
      parsed.searchParams.set("source", "shopify_pdp");
      parsed.searchParams.set("hide_title", "1");
      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function ensureStyles() {
    if (document.getElementById("alunir-booking-dynamic-styles")) return;
    var style = document.createElement("style");
    style.id = "alunir-booking-dynamic-styles";
    style.textContent =
      '.alunir-booking-offerings{margin:18px 0}.alunir-booking-offerings__title,.alunir-booking-offering-group__title{font-size:11px;letter-spacing:.16em;text-transform:uppercase}.alunir-booking-offering-group{margin-top:14px}.alunir-booking-offering-group__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-top:7px}.alunir-booking-offering{appearance:none;border:1px solid #d8d5cf;border-radius:4px;background:#fff;padding:12px;text-align:left;color:#111;cursor:pointer}.alunir-booking-offering:hover,.alunir-booking-offering[aria-pressed=true]{border-color:#111;background:#f7f5f1}.alunir-booking-offering.is-event{grid-column:1/-1}.alunir-booking-offering__label,.alunir-booking-offering__meta{display:block}.alunir-booking-offering__label{font-size:14px}.alunir-booking-offering__meta{margin-top:4px;font-size:11px;line-height:1.5;color:#666}.alunir-booking-offerings__loading,.alunir-booking-offerings__content{font-size:12px;color:#666}.alunir-booking-source-page .variant-wrapper{display:none!important}.alunir-booking-faq{margin-top:22px;border-top:1px solid #d8d5cf}.alunir-booking-faq__title{margin:20px 0 8px;font-family:GrandSlang-Roman,Georgia,serif;font-size:23px}.alunir-booking-faq details{border-bottom:1px solid #d8d5cf}.alunir-booking-faq summary{position:relative;padding:15px 32px 15px 0;cursor:pointer;font-size:14px;list-style:none}.alunir-booking-faq summary::-webkit-details-marker{display:none}.alunir-booking-faq summary:after{content:"+";position:absolute;right:4px;top:13px;font-size:20px}.alunir-booking-faq details[open] summary:after{content:"−"}.alunir-booking-faq details>div{padding:0 24px 15px 0;color:#666;font-size:13px;line-height:1.6}.alunir-booking-faq details>div p{margin:0 0 8px}.alunir-booking-faq details>div p:last-child{margin-bottom:0}@media(max-width:740px){.alunir-booking-offering-group__grid{grid-template-columns:1fr}.alunir-booking-offering.is-event{grid-column:auto}}';
    document.head.appendChild(style);
    var modalStyle = document.createElement("style");
    modalStyle.textContent =
      "html.alunir-booking-modal-open,html.alunir-booking-modal-open body{overflow:hidden}.alunir-booking-modal{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.42);padding:14px;color:#111}.alunir-booking-modal.is-open{display:flex}.alunir-booking-modal__dialog{width:min(920px,100%);max-height:min(820px,calc(100vh - 28px));display:flex;flex-direction:column;overflow:hidden;border:1px solid rgba(0,0,0,.18);border-radius:5px;background:#fcfbf8}.alunir-booking-modal__header{display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #e8e8e1;padding:16px 18px}.alunir-booking-modal__title{font-family:GrandSlang-Roman,Georgia,serif;font-size:24px}.alunir-booking-modal__close{width:34px;height:34px;border:0;background:transparent;font-size:24px;cursor:pointer}.alunir-booking-modal__body{position:relative;background:#fcfbf8}.alunir-booking-modal__loading{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:#fcfbf8;font-size:12px}.alunir-booking-modal.is-loaded .alunir-booking-modal__loading{display:none}.alunir-booking-modal iframe{display:block;width:100%;height:min(750px,calc(100vh - 154px));border:0}.alunir-booking-modal__footer{display:flex;justify-content:flex-end;border-top:1px solid #e8e8e1;padding:10px 18px}.alunir-booking-modal__direct{font-size:11px;text-transform:uppercase;letter-spacing:.16em;color:#111}@media(max-width:740px){.alunir-booking-modal{padding:0}.alunir-booking-modal__dialog{width:100vw;height:100dvh;max-height:none;border:0;border-radius:0}.alunir-booking-modal iframe{height:calc(100dvh - 104px)}}";
    document.head.appendChild(modalStyle);
  }

  function ensureModal() {
    var existing = document.querySelector("[data-alunir-booking-modal]");
    if (existing) return existing;
    var modal = document.createElement("div");
    modal.className = "alunir-booking-modal";
    modal.setAttribute("data-alunir-booking-modal", "true");
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-label", root.getAttribute("data-alunir-booking-modal-aria") || "");
    modal.innerHTML =
      '<div class="alunir-booking-modal__dialog"><div class="alunir-booking-modal__header"><div class="alunir-booking-modal__title"></div><button class="alunir-booking-modal__close" type="button" data-alunir-booking-close aria-label=""></button></div><div class="alunir-booking-modal__body"><div class="alunir-booking-modal__loading"></div><iframe title="" data-alunir-booking-frame loading="lazy"></iframe></div><div class="alunir-booking-modal__footer"><a class="alunir-booking-modal__direct" data-alunir-booking-direct target="_blank" rel="noopener"></a></div></div>';
    var modalTitle = modal.querySelector(".alunir-booking-modal__title");
    var modalLoading = modal.querySelector(".alunir-booking-modal__loading");
    var modalDirect = modal.querySelector("[data-alunir-booking-direct]");
    var modalClose = modal.querySelector("[data-alunir-booking-close]");
    var modalFrame = modal.querySelector("[data-alunir-booking-frame]");
    modalTitle.textContent = root.getAttribute("data-alunir-booking-modal-title") || "";
    modalLoading.textContent = root.getAttribute("data-alunir-booking-modal-loading") || "";
    modalDirect.textContent = root.getAttribute("data-alunir-booking-modal-direct") || "";
    modalClose.setAttribute("aria-label", root.getAttribute("data-alunir-booking-modal-close") || "");
    modalClose.textContent = "×";
    modalFrame.setAttribute("title", root.getAttribute("data-alunir-booking-modal-aria") || "");
    if (modalTitle && pageContent && pageContent.modal_title)
      modalTitle.textContent = pageContent.modal_title;
    if (modalLoading && pageContent && pageContent.modal_loading_text)
      modalLoading.textContent = pageContent.modal_loading_text;
    if (modalDirect && pageContent && pageContent.modal_direct_label)
      modalDirect.textContent = pageContent.modal_direct_label;
    document.body.appendChild(modal);
    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal("backdrop");
    });
    modal.querySelector("[data-alunir-booking-close]").addEventListener("click", function () {
      closeModal("close_button");
    });
    modal.querySelector("[data-alunir-booking-frame]").addEventListener("load", function () {
      modal.classList.add("is-loaded");
    });
    return modal;
  }

  function openModal() {
    var url = currentBookingUrl();
    var modal = ensureModal();
    modalState = { completed: false, openedAt: Date.now() };
    modal.querySelector("[data-alunir-booking-direct]").href = url;
    modal.classList.remove("is-loaded");
    modal.querySelector("[data-alunir-booking-frame]").setAttribute("src", embedUrl(url));
    modal.classList.add("is-open");
    document.documentElement.classList.add("alunir-booking-modal-open");
    modal.querySelector("[data-alunir-booking-close]").focus();
    track("alunir_booking_modal_open");
  }

  function closeModal(reason) {
    var modal = document.querySelector("[data-alunir-booking-modal]");
    if (!modal || !modal.classList.contains("is-open")) return;
    modal.classList.remove("is-open");
    document.documentElement.classList.remove("alunir-booking-modal-open");
    if (modalState && !modalState.completed) {
      track("alunir_booking_modal_aborted", {
        close_reason: reason || "unknown",
        modal_open_seconds: Math.max(0, Math.round((Date.now() - modalState.openedAt) / 1000)),
      });
    }
  }

  function installSupportLinks() {
    root.querySelectorAll("[data-alunir-support-open]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        var chatButton = document.querySelector(
          '[aria-label="Chat öffnen"], [aria-label="Ouvrir le chat"]',
        );
        if (!chatButton) return;
        event.preventDefault();
        chatButton.click();
      });
    });
  }

  function collapsePersistedChat() {
    try {
      window.localStorage.removeItem("alunir_widget_open");
    } catch (error) {}
    var closeIfOpen = function () {
      var close = document.querySelector(
        '[aria-label="Chat schliessen"], [aria-label="Fermer le chat"]',
      );
      if (!close) return false;
      close.click();
      return true;
    };
    if (closeIfOpen()) return;
    var observer = new MutationObserver(function () {
      if (closeIfOpen()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 5000);
  }
  function install() {
    root = document.querySelector("[data-alunir-booking-handle]");
    if (!root) return;
    ensureStyles();
    document.documentElement.classList.add("alunir-booking-source-page");
    root
      .querySelector("[data-alunir-booking-fallback]")
      .addEventListener("click", function (event) {
        event.preventDefault();
        openModal();
      });
    var mobileButton = root.querySelector("[data-alunir-booking-mobile-button]");
    if (mobileButton) mobileButton.addEventListener("click", openModal);
    installSupportLinks();
    collapsePersistedChat();
    loadOfferings();
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeModal("escape");
  });
  window.addEventListener("message", function (event) {
    if (event.origin !== BOOKING_ORIGIN || !event.data) return;
    if (event.data.type === "alunir:booking-ready") {
      sendAttributionToBooking(event.source);
    } else if (event.data.type === "alunir:booking-complete") {
      if (modalState && !modalState.completed) {
        modalState.completed = true;
        var browserScheduleSent = publishMetaSchedule(event.data.eventId);
        track("alunir_booking_complete", {
          booking_id: event.data.bookingId || null,
          meta_event_id: event.data.eventId || null,
          meta_browser_schedule_sent: browserScheduleSent,
        });
      }
    } else if (event.data.type === "alunir:booking-group-request") {
      track("alunir_booking_group_request", { request_id: event.data.requestId || null });
    } else if (event.data.type === "alunir:booking-step") {
      track("alunir_booking_step", {
        booking_step: event.data.step || null,
        booking_draft_id: event.data.draftId || null,
        selected_date: event.data.selectedDate || null,
        selected_starts_at: event.data.selectedStartsAt || null,
      });
    } else if (event.data.type === "alunir:booking-close") {
      closeModal("booking_app");
    }
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", install);
  else install();
})();
